import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        // Admin-Listen und die meisten UI-Queries brauchen keine sofortige Frische.
        // 30 s Cache vermeidet Refetch bei jedem Route-Mount und Tab-Fokus.
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: 1,
      },
    },
  });

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    // Beim Überfahren eines Links werden Seitencode, Zugangsprüfung und
    // Loader-Daten schon geholt. Das entfernt im internen Bereich die
    // längste Wartezeit: bisher startete alles erst nach dem Klick.
    defaultPreload: "intent",
    defaultPreloadDelay: 60,
    // Query kontrolliert Frische; Router-Preload-Cache darf für 30 s cachen,
    // damit Link-Hover keine Doppel-Requests auslöst.
    defaultPreloadStaleTime: 30_000,
  });


  return router;
};
